import { select, takeEvery } from 'redux-saga/effects';
import { Action } from 'redux-actions';
import sagaUtility from '../../blocks/utils/saga-utility';
import { SearchCouponsRequest } from '../../models/tariff/SearchCouponsRequest';
import { GetTrafficAreasActionTypes, GetTrafficAreasGeographyActionTypes, SearchCouponsActionTypes } from './types';
import { getTrafficAreasActions, getTrafficAreasGeographyActions, searchCouponsActions } from './actions';
import TariffService from '../../services/tariff.service';
import FleetService from '../../services/fleet.service';
import { TrafficAreaGeography } from '../../models/tariff/trafficAreas/TrafficAreaGeography';
import { ApplicationState } from '..';

export default function* tariffSaga() {
    yield takeEvery(SearchCouponsActionTypes.REQUEST, searchCouponsRequest);

    yield takeEvery(GetTrafficAreasActionTypes.REQUEST, getTrafficAreasRequest);

    yield takeEvery(GetTrafficAreasGeographyActionTypes.REQUEST, getTrafficAreasGeographyRequest);
}

function* searchCouponsRequest(action: Action<SearchCouponsRequest>) {
    yield sagaUtility(action.payload, TariffService.searchCoupons, searchCouponsActions.success, searchCouponsActions.failure);
}

function* getTrafficAreasRequest(action: Action<any>) {
    yield sagaUtility(action.payload, TariffService.getTrafficAreas, getTrafficAreasActions.success, getTrafficAreasActions.failure, false, false);
}

function* getTrafficAreasGeographyRequest(action: Action<any>) {
    const trafficAreasGeography: TrafficAreaGeography[] | undefined = yield select((state: ApplicationState) => state.tariff.trafficAreasGeography);
    if (trafficAreasGeography && trafficAreasGeography.length > 0)
         return;

    yield sagaUtility(action.payload, FleetService.GetTrafficAreasGeography, getTrafficAreasGeographyActions.success, getTrafficAreasGeographyActions.failure, false, false);
}
